import moment from 'moment'

import i18n from 'i18n'

export const locales = {
  french: 'fr-CA',
  english: 'en',
}

export const isFrenchLocale = () => {
  const currentLocale = i18n.default.language

  return currentLocale === locales.french
}

export const setI18nLocale = (locale: string) => {
  i18n.changeLanguage(locale)
  moment.locale(locale)
}
